import React from 'react';
import {
  DescriptionBlock,
  DescriptionTerm,
  DetailsDescription,
} from '../EntitySelectionPanelUI';

interface IProps {
  description: string;
}

const NodeDetailsDescription = ({ description }: IProps) => {
  return (
    <DescriptionBlock>
      <DescriptionTerm>Description:</DescriptionTerm>
      <DetailsDescription>{description}</DetailsDescription>
    </DescriptionBlock>
  );
};

export default NodeDetailsDescription;
